module.exports = __webpack_public_path__ + "img/share.4f94eab3.svg";